import React from 'react';
import moment from 'moment';

import {
    Card,
    Col,
    Row,
    Form,
    Input,
    Button,
    Radio,
    Slider,
    Checkbox,
    message,
    DatePicker,
} from "antd";
import 'moment/locale/cs.js';
import locale from 'antd/es/date-picker/locale/cs_CZ';
import eshopData from '../enums/data.json'
import OrderedSummary from './OrderedSummary'
import { sendBilling } from './emailBilling'
import { withCookies } from 'react-cookie';
import { navigate } from "@reach/router"
import { ConfigProvider } from 'antd';
import Holidays from 'date-holidays';

const allowedDeliveryDays = eshopData.allowedDeliveryDays
const customDisabledDates = new Set(
    (eshopData.customDisabledDates || [])
        .map(date => moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD'))
);

const holidays = new Holidays('CZ');

function isBlockedDate(date) {
    if (!date) return false;
    const dateString = date.format('YYYY-MM-DD');
    if (customDisabledDates.has(dateString)) return true;
    return !!holidays.isHoliday(date.toDate());
}


const getInput = (props, inclRows) => {
    if (inclRows) {
        return (
            <Row>
                <Col span={24}>
                    <Form.Item
                        {...props}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
        )

    } else {

        return (
            <Form.Item
                {...props}
            >
                <Input />
            </Form.Item>
        )
    }
}
function rangeDict(start, end) {
    const result = {};
    for (let i = start; i < end; i += 2) {
        result[`${i}`] = `${i}h`
    }
    result[`${end}`] = `${end}h`
    return result;
}

function disabledDate(current) {
    // disabling deliveries here, disabledSimpleDate for pickups

    if (!current) return false;
    if (isBlockedDate(current)) return true;

    const isPast = current && current < moment().set({ "hour": 0, "minute": 0, "second": 0 })
    const notAllowedDay = !allowedDeliveryDays.includes(current.isoWeekday())
    // console.log(current)
    // console.log(isPast, notAllowedDay)
    if (isPast || notAllowedDay) {
        return true
    }

    if (current.isSame(moment(), 'day')) {
        // asking about today
        const isPastTodaysLimit = current > moment().set({ "hour": eshopData.rules.limitOrderHours, "minute": eshopData.rules.limitOrderMinutes, "second": 0 })
        if (isPastTodaysLimit) {
            return true
        }
    }
    return false
}

function disabledSimpleDate(current) {

    // if (moment("2023-07-05", "YYYY-MM-DD").isSame(current, 'day')) return true
    // if (moment("2023-07-06", "YYYY-MM-DD").isSame(current, 'day')) return true
    // Can not select days before today and today at some time

    if (!current) return false;
    if (isBlockedDate(current)) return true;


    const isPast = current && current < moment().set({ "hour": 0, "minute": 0, "second": 0 })

    const notAllowedDay = [6, 7].includes(current.isoWeekday())
    if (isPast || notAllowedDay) {
        return true
    }

    if (current.isSame(moment(), 'day')) {
        // asking about today
        const isPastTodaysLimit = current > moment().set({ "hour": 16, "minute": 30, "second": 0 })
        if (isPastTodaysLimit) {
            return true
        }
    }
    return false
}

const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
};

class OrderForm extends React.Component {
    state = {
        isDelivery: true,
        disableSubmit: false,
        notAcknowledged: true
    }


    render() {
        const layout = {
            labelCol: { span: 16 },
            wrapperCol: { span: 20 },
        };
        const configDatePicker = {
            rules: [{ type: 'object', required: true, message: 'Vyberte datum doručení!' }],
        };
        const { cookies } = this.props
        return (
            <ConfigProvider locale={locale}>

                <Form
                    {...layout}
                    layout="vertical"
                    name="order_form"
                    onFinish={this.handleSubmit}
                    onFinishFailed={onFinishFailed}
                    initialValues={cookies.getAll()}
                >
                    <Card title="Údaje k objednávce" bordered={false}>
                        {getInput({ label: 'Jméno a příjmení', name: "name", rules: [{ required: true, message: 'Prosím, uvěďte jméno' }] }, true)}
                        {/* <Row>
                        <Col span={14}> */}
                        {getInput({ label: 'Adresa', name: "address", rules: [{ required: true, message: 'Prosím, uvěďte adresu doručení' }] }, true)}
                        {/* </Col>
                        <Col span={5} offset={1}>
                            {getInput({ label: 'PSČ', name: "psc", rules: [
                                { required: true, type: "number", min: 1, max: 99999, message: 'Prosím, zadejte validní PSČ.' },
                                // {validator:validatePSC, message: 'Prosím, zadejte  PSČ.'}
                                ] }, false)}
                        </Col>
                    </Row> */}

                        {getInput({ label: 'Telefonnní číslo', name: "phone", rules: [{ required: true, message: 'Prosím, uvěďte kontakt' }] }, true)}
                        {getInput({ label: 'Email', name: "email", rules: [{ required: true, message: 'Prosím, uvěďte email', type: 'email' }] }, true)}

                        <Form.Item name="is_delivery" label="Způsob doručení" initialValue={true}>
                            <Radio.Group onChange={(e) => this.setState({ isDelivery: e.target.value })} >
                                <Radio value={true}>Dovoz</Radio>
                                <Radio value={false}>Vyzvednutí v pivovaru</Radio>
                            </Radio.Group>
                        </Form.Item>

                        {this.state.isDelivery &&
                            <div>
                                <Form.Item name="delivery_date" label="Datum doručení" {...configDatePicker}>
                                    <DatePicker
                                        format="YYYY-MM-DD"
                                        disabledDate={disabledDate}
                                        locale={locale}
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Doba doručení"
                                    name="delivery_time"
                                    rules={[{ required: true, message: 'Vyberte dobu doručení' }]}
                                >
                                    <Slider range min={12} max={18}
                                        marks={rangeDict(12, 18)} defaultValue={[14, 16]} step={1} />
                                </Form.Item>
                            </div>
                        }
                        {
                            !this.state.isDelivery &&
                            <div>
                                <Form.Item name="delivery_date" label="Datum vyzvednutí" {...configDatePicker}>
                                    <DatePicker
                                        format="YYYY-MM-DD"
                                        disabledDate={disabledSimpleDate}
                                        locale={locale}
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Doba vyzvednutí"
                                    name="delivery_time"
                                    rules={[{ required: true, message: 'Vyberte dobu vyzvednutí' }]}
                                >
                                    <Slider range min={10} max={17}
                                        marks={rangeDict(10, 17)} defaultValue={[13, 14]}
                                        step={1}
                                    />
                                </Form.Item>
                            </div>
                        }




                    </Card>

                    <Card title="Souhrn objednávky" bordered={false}>
                        <OrderedSummary orderData={this.props.orderData} isDelivery={this.state.isDelivery} />
                    </Card>
                    <Form.Item name="remember" valuePropName="checked">
                        <Checkbox onChange={(e) => { this.setState({ notAcknowledged: !e.target.checked }) }}>Souhlasím s podmínkami a zpracováním osobních údajů</Checkbox>
                    </Form.Item>
                    <Form.Item>
                        <center>
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="ant-btn-submit"
                                disabled={(this.state.isDelivery && this.props.orderData.total < eshopData.rules.minOrder) || this.state.disableSubmit || this.state.notAcknowledged}
                            >
                                Odeslat objednávku
                            </Button>

                        </center>
                    </Form.Item>
                </Form>
            </ConfigProvider>
        )
    }

    handleSubmit = (values) => {
        const { cookies } = this.props

        console.log('submit form')
        console.log(values)
        console.log(JSON.stringify(values))

        cookies.set('name', values.name)
        cookies.set('address', values.address)
        cookies.set('phone', values.phone)
        cookies.set('email', values.email)

        const updatedValues = { ...values }
        const orderList = Object.values(this.props.orderData.shopping).filter(el => el.items > 0).map(
            el => {
                return (`${el.shortLabel}: ${el.items} ks`)
            })


        updatedValues.status = "received"
        updatedValues.delivery_date = values.delivery_date.format('YYYY-MM-DD')
        updatedValues.delivery_time = `${values.delivery_time[0]}h-${values.delivery_time[1]}h`
        updatedValues.total = this.props.orderData.total
        updatedValues.order = orderList.join('/*/')
        updatedValues.order_email = orderList.join('\n')
        updatedValues.order_created = moment().format('YYYY-MM-DD HH:mm')


        fetch('https://m9qknpgp61.execute-api.eu-central-1.amazonaws.com/prod/submit-order/', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
            },
            body: JSON.stringify(updatedValues)
        }).
            then((success) => {
                console.log(success)
            })
            .catch((err) => { console.log(err); message.error('Omlouváme se, máme technické problémy. Zkuste to, prosím, za chvíli znovu.') })

        let vyzvednuti, payment;
        if (this.state.isDelivery) {
            vyzvednuti = `Blíže k datu doručení ${updatedValues.delivery_date} potvrdíme čas který jste vybral/vybrala mezi ${updatedValues.delivery_time}`
            payment = `Při dodání můžete zaplatit pouze hotově. Připravte si, prosím, blízkou částku.`
        } else {
            vyzvednuti = `Potvrzujeme, že na Vás bude čekat objednávka ${updatedValues.delivery_date}.`
            payment = `Při vyzvednutí můžete zaplatit hotově nebo kartou.`

        }
        const templateParams = {
            send_to: updatedValues.email,
            order: updatedValues.order_email,
            pickup: vyzvednuti,
            payment: payment,
        };
        sendBilling(templateParams)

        message.success(`Objednávka byla úspěšně doručena. Budeme vás dále kontaktovat emailem.`)
        this.setState({ disableSubmit: true })
        setTimeout(function () { navigate("/thankyou"); }, 300);


    }

}
export default withCookies(OrderForm);
